{
  "WEBCHAT": {
    "WIDGET": {
      "INPUT_MESSAGE": "Type here...",
      "DEFAULT_ASSISTANT_NAME": "Chat Receptionist"
    },
    "NEW_MESSAGE_RECEIVED": "New message received",
    "ERROR_SENDING_MESSAGE": "Failed to send message, please try again later.",
    "ERROR_CREATING_CONVERSATION": "Failed to create conversation, please try again later."
  }
}
